let reauthHandler: (() => Promise<boolean>) | null = null
let inFlightReauth: Promise<boolean> | null = null

export const setReauthHandler = (handler: (() => Promise<boolean>) | null) => {
  reauthHandler = handler
}

export const requestReauth = async (): Promise<boolean> => {
  if (!reauthHandler) return false
  if (!inFlightReauth) {
    inFlightReauth = reauthHandler().finally(() => {
      inFlightReauth = null
    })
  }
  return inFlightReauth
}
